import { EMPTY_ARRAY, IApplicationState, TBoardId, TCustomPropertyId } from '../../../../types/types';
import { getBoardUserMeta } from '../../boardUserMetas/selectors/getBoardUserMeta';
import { getBoardDefaultCardPreviewCustomProperties } from './getBoardDefaultCardPreviewCustomProperties';

export const getBoardUserMetaCardPreviewCustomProperties = (
    state: IApplicationState,
    boardId: TBoardId
): TCustomPropertyId[] => {
    const userBoardMeta = getBoardUserMeta(state, boardId);
    return userBoardMeta && userBoardMeta.cardPreviewCustomProperties || getBoardDefaultCardPreviewCustomProperties(state, boardId);
};
